import React from "react";
import { EmailField, Form, PasswordField, SubmitButton, Warning } from "@culturehq/components";

import { t, Trans } from "app/utils";

const submitPhrase = (displayPasswordField, submitting) => {
  if (submitting) {
    return t("Submitting...");
  }
  return displayPasswordField ? t("Sign In") : t("Submit");
};

const LoginForm = ({ errorMessage, displayPasswordField, onSubmit }) => (
  <Form onSubmit={onSubmit}>
    {errorMessage && <Warning>{errorMessage}</Warning>}
    {
      displayPasswordField
        ? <PasswordField name="password" autoFocus><Trans>Password</Trans></PasswordField>
        : <EmailField name="email" required autoFocus><Trans>Email</Trans></EmailField>
    }
    <SubmitButton primary>
      {submitting => submitPhrase(displayPasswordField, submitting)}
    </SubmitButton>
  </Form>
);

export default LoginForm;
